import * as actions from '../actions/Qa'

const initialState = {
  error: '',
  packageLookupLoading: false,
  lookupSuccess: false,
  qaPackage: null,
  stationSubmitSuccess: false,
  calculatorLoading: false,
  calculatorSuccess: false,
  calculatorValues: null,
  countDownLoading: false,
  countDownValues: null
}

const QaReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_PACKAGE_LOOKUP_LOADER:
      return {
        ...state,
        packageLookupLoading: action.loading
      }
    case actions.GET_QA_PACKAGE:
      return {
        ...state,
        qaPackage: action.qaPackage
      }
    case actions.GET_QA_PACKAGE_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.POST_STUFF_STATION_SUCCESS:
      return {
        ...state,
        stationSubmitSuccess: action.stationSubmitSuccess
      }
    case actions.POST_STUFF_STATION_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.POST_FINAL_SCAN_STATION_SUCCESS:
      return {
        ...state,
        stationSubmitSuccess: action.stationSubmitSuccess
      }
    case actions.POST_FINAL_SCAN_STATION_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.POST_WEIGHT_STATION_SUCCESS:
      return {
        ...state,
        stationSubmitSuccess: action.stationSubmitSuccess
      }
    case actions.POST_WEIGHT_STATION_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.SET_CALCULATOR_LOADER:
      return {
        ...state,
        calculatorLoading: action.loading
      }
    case actions.POST_CALCULATOR_RESULTS_SUCCESS:
      return {
        ...state,
        calculatorSuccess: action.calculatorSuccess
      }
    case actions.POST_CALCULATOR_RESULTS_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.GET_QA_PACKAGE_SUCCESS:
      return {
        ...state,
        lookupSuccess: action.lookupSuccess
      }
    case actions.GET_CALCULATOR_VALUES_SUCCESS:
      return {
        ...state,
        calculatorValues: action.values
      }
    case actions.GET_CALCULATOR_VALUES_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.SET_COUNTDOWN_LOADER:
      return {
        ...state,
        countDownLoading: action.loading
      }
    case actions.GET_COUNTDOWN_VALUES_SUCCESS:
      return {
        ...state,
        countDownValues: action.values
      }
    case actions.GET_COUNTDOWN_ERROR:
      return {
        ...state,
        error: action.error
      }
    case 'RESET_INITIAL_STATE':
      return {
        ...initialState,
        qaPackage: null
      }
    default:
      return state
  }
}

export default QaReducer
